import Connect from "@/components/button/connect";

export default function Navbar() {
  return (
    <>
      <div className="mx-auto px-4 py-3 sm:px-6">
        <div className="relative flex justify-between">
          <div className="flex">
            
          </div>
          <div className="flex flex-wrap">
            <Connect />
          </div>
        </div>
      </div>
    </>
  );
}
